import React from "react";
import { AlertIcon } from "../../common/icons/Alert";
import { ReloadIcon } from "../../common/icons/Reload";
import { useStyles } from "./styles";

export const Error = ({ title, subtitle, actionLabel, action }) => {
  const classes = useStyles();

  return (
    <div className={classes.error}>
      <AlertIcon />

      <h3 className={classes.title}>{title}</h3>

      <div className={classes.subtitle}>{subtitle}</div>

      <button className={classes.action} onClick={() => action()}>
        <ReloadIcon />
        <span className={classes.actionLabel}>{actionLabel}</span>
      </button>
    </div>
  );
};

export default Error;
